module.exports = __webpack_public_path__ + "static/logo.36efc25e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CallToActionForm/logo.jpg
// module id = 7139
// module chunks = 6674870452060